'use strict';

const getSuffixRE = (suffix) => new RegExp(`${suffix}$`);

const getSuffixedKey = (suffixRE, key) => suffixRE.test(key) ? key.replace(suffixRE, '') : key;

const replaceSuffixFromKeys = (object, suffixRE) => {
    return Object.keys(object).reduce((result, key) => {
        result[getSuffixedKey(suffixRE, key)] = object[key];
        return result;
    }, {});
};

const removeSuffixFromKeys = (object, suffix) => replaceSuffixFromKeys(object, getSuffixRE(suffix));

const filterUnwantedKeys = (object, patternToExclude) => {
    return Object.keys(object)
        .filter((key) => !patternToExclude.test(key))
        .reduce((result, key) => {
            result[key] = object[key];
            return result;
        }, {});
};

module.exports = {
    preProcessKeysByPolicyAndApplicationFlow(policy, keys = {}) {
        const result = removeSuffixFromKeys(keys, `:${policy}`);

        if (Odigeo.Utils.isRequestApp('dp')) {
            Odigeo._.assign(result, removeSuffixFromKeys(keys, `:${policy}:dp`));
        }

        return filterUnwantedKeys(result, /:/);
    },

    replaceVoucherKeys(keys) {
        const pwgSubmitDk = Odigeo._.get(keys, 'paymentSubmitPWG.FAN_PLUS4819', '');
        const pwgTooltipDk = Odigeo._.get(keys, 'payWithGuaranteeTooltip.FAN_PLUS4819', '');
        const pwgTooltipDpDk = Odigeo._.get(keys, 'payWithGuaranteeTooltipDP.FAN_PLUS4819', '');
        const pwgSubmitSm = Odigeo._.get(keys, 'refundableButtonTitle.FAN_PLUS4819:CANXSELF', '');
        const pwgTooltipTitleSm = Odigeo._.get(keys, 'refundableTooltipTitle.FAN_PLUS4819:CANXSELF', '');
        const payTooltipTitleSm = Odigeo._.get(keys, 'noRefundableTooltipTitle.FAN_PLUS4819', '');
        const pwgTooltipSm = Odigeo._.get(keys, 'refundableTooltipDescription.FAN_PLUS4819:CANXSELF', '');
        const pwgTooltipDpSm = Odigeo._.get(keys, 'refundableTooltipDescription.FAN_PLUS4819:CANXSELF:dp', '');
        return Odigeo._.extend({}, keys, {
            paymentSubmitPWG: pwgSubmitDk,
            payWithGuaranteeTooltip: pwgTooltipDk,
            payWithGuaranteeTooltipDP: pwgTooltipDpDk,
            ['refundableButtonTitle:CANXSELF']: pwgSubmitSm,
            ['refundableTooltipTitle:CANXSELF']: pwgTooltipTitleSm,
            ['noRefundableTooltipTitle']: payTooltipTitleSm,
            ['refundableTooltipDescription:CANXSELF']: pwgTooltipSm,
            ['refundableTooltipDescription:CANXSELF:dp']: pwgTooltipDpSm,
        });
    },
};
